import React from 'react';
import { Row } from '@tanstack/react-table';
import { Tag } from '@blueprintjs/core';
import { FieldMappingTreeNode } from '../../../../../../utils/fieldMappingTreeBuilder';
import { ExpandableCell } from './ExpandableCell';
import { getTypeBadgeClass, getTypeLabel } from '../utils/fieldTypeHelpers';
import styles from './TreeFieldMappingsTable.module.sass';

export interface DestinationFieldCellProps {
  row: Row<FieldMappingTreeNode>;
  node: FieldMappingTreeNode;
}

/**
 * Destination field cell component for TreeFieldMappingsTable
 * Renders the destination field name with type badge in an expandable cell
 */
export const DestinationFieldCell: React.FC<DestinationFieldCellProps> = ({
  row,
  node,
}) => {
  return (
    <ExpandableCell row={row}>
      <span
        className={node.isLeaf ? styles.leafField : styles.objectField}
      >
        {node.displayName}
        {node.required && <span className={styles.required}>*</span>}
      </span>
      {/* Show inline type badge for all nodes */}
      <Tag
        round
        minimal
        className={`${getTypeBadgeClass(node.type)} ${
          styles.inlineTypeBadge
        }`}
      >
        {getTypeLabel(node)}
      </Tag>
    </ExpandableCell>
  );
};
